// Domain state constants — single source of truth for the string values the
// backend contract expects. Frozen so a typo throws instead of silently
// creating a new key. NOTE: tests intentionally use raw literals as fixtures
// (so a drift here is caught), so do NOT import these into tests.

export const ORDER_TYPE = Object.freeze({
  DELIVERY: 'delivery',
  TAKEOUT:  'takeout',
  CATERING: 'catering',
});

export const PAYMENT = Object.freeze({
  CARD: 'card',
  CASH: 'cash',
});

// Ordering flow variant (from _EZCL.data.ordering.flow) — drives navigation
// guards and which payment/render path the SPA takes.
export const FLOW = Object.freeze({
  ONE:     'one',
  DEFAULT: 'default',
});

// Placeholder token sent in the order payload before Clover's real
// tokenization replaces it (Checkout / Payment / PaymentAdditional).
export const CLOVER_TOKEN_STUB = 'clv_token';
